import React from 'react';

// Lo que ve alguien cuyo acceso todavía no está activo, se le venció o quedó
// suspendido.
//
// Antes no había nada: el servidor respondía 402 en todas las rutas y la
// aplicación se limitaba a escribirlo en la consola. Quien acababa de
// registrarse entraba y se encontraba un panel en ceros, sin una sola línea
// que le dijera qué pasaba ni qué hacer. Es la primera pantalla que ve alguien
// que acaba de pagar.

const MENSAJES = {
  pendiente: {
    emoji: '⏳',
    titulo: 'Tu cuenta está creada',
    texto: 'Falta que activemos el acceso. En cuanto confirmemos tu pago lo abrimos y entras con este mismo correo.',
    detalle: 'Si ya pagaste, avísanos y lo revisamos.',
    color: '#2563eb',
    fondo: '#eff6ff'
  },
  vencida: {
    emoji: '🔔',
    titulo: 'Tu acceso venció',
    texto: 'Renuévalo y sigues donde lo dejaste.',
    detalle: 'Tus clientes, préstamos y pagos siguen guardados. No se borra nada durante 30 días.',
    color: '#b45309',
    fondo: '#fffbeb'
  },
  suspendida: {
    emoji: '⛔',
    titulo: 'Tu acceso está suspendido',
    texto: 'Escríbenos para revisar qué pasó.',
    detalle: 'Tus datos siguen guardados.',
    color: '#b91c1c',
    fondo: '#fef2f2'
  }
};

function CuentaBloqueada({ estado, email, onSalir }) {
  const m = MENSAJES[estado] || MENSAJES.pendiente;

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '14px',
        padding: '38px 32px',
        maxWidth: '440px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 50px rgba(0,0,0,.25)'
      }}>
        <div style={{ fontSize: '52px', lineHeight: 1 }}>{m.emoji}</div>

        <h2 style={{ margin: '18px 0 10px', color: m.color, fontSize: '22px' }}>
          {m.titulo}
        </h2>

        <p style={{ margin: '0 0 14px', color: '#374151', fontSize: '15px', lineHeight: 1.6 }}>
          {m.texto}
        </p>

        <div style={{
          background: m.fondo,
          borderRadius: '8px',
          padding: '14px',
          fontSize: '14px',
          color: '#374151',
          marginBottom: '22px'
        }}>
          {m.detalle}
        </div>

        {email && (
          <p style={{ color: '#6b7280', fontSize: '13px', margin: '0 0 22px' }}>
            Tu cuenta: <strong>{email}</strong>
          </p>
        )}

        <a
          href="/manual"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'block',
            padding: '12px',
            borderRadius: '8px',
            background: '#667eea',
            color: 'white',
            textDecoration: 'none',
            fontWeight: 'bold',
            marginBottom: '10px'
          }}
        >
          📗 Ver el manual mientras tanto
        </a>

        <button
          onClick={onSalir}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            background: 'white',
            color: '#374151',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Salir
        </button>
      </div>
    </div>
  );
}

export default CuentaBloqueada;
